const normalizeTravelData = (lwData) => {
  const {
    travel_imageURL,
    travel_pageURL,
    travel_region,
    travel_vertical,
    travel_destination
  } = lwData || {};
  const productName = travel_region ? `${travel_region} ${travel_vertical}` : `${travel_destination} ${travel_vertical}`;
  return {
    isCostcoTravel: true,
    isPublished: true,
    productActions: {
      type: "SeeDetails"
    },
    productInfoData: {
      partNumber: `travelDestination_${productName}`,
      productImageUrl: travel_imageURL,
      productLinkUrl: travel_pageURL,
      productName
    }
  };
};
export {
  normalizeTravelData
};
